import axios from "axios";
import { baseURL } from "../constant";


const instance = axios.create({
    baseURL
})

export {
    instance
}

export const PYTHON_SERVER_URL = 'https://python.immarsify.com/api/v1'